import React from "react";
import { Grid } from "@mui/material/";
import AssetAttributes from "./AssetAttributes";
import Core from "./Core";
import { format, helpers } from "../../../../common/lib";
import GridColumn from "../GridColumn";
import MonetaryValues from "./MonetaryValues";
import { useSelector } from "react-redux";

type Props = {
    asset: any,
    attributes: Array<any>
};
/**
 * Asset Detail Component
 */
export default ({ asset, attributes }: Props) => {
    const getFormatedDate = (formatDate) => `${format.dateTimeNew(formatDate)}`;
    const { assetStatus } = useSelector((state) => state.typesList);

    const getAssetStatus = (status) =>
        helpers.getListItemForId(assetStatus, status).name;
    const lastUploadDate =
        asset.upload && asset.upload.statusDate
            ? getFormatedDate(asset.upload.statusDate)
            : "";

    const lastAuditDate = asset.lastAuditDate
        ? getFormatedDate(asset.lastAuditDate)
        : "";

    const lastSeenDate = asset.lastSeenDate
        ? getFormatedDate(asset.lastSeenDate)
        : "";

    const lastUploadSource =
        asset.upload && asset.upload.originalFilename
            ? asset.upload.originalFilename.split("/").pop()
            : "";

    const status = asset.isLive ? "live" : "sold";

    return (
        <>
            <Grid container spacing={3}>
                <Core {...asset} />
                <AssetAttributes
                    assetTypeId={asset.type}
                    attributes={attributes}
                />
            </Grid>
            <Grid container spacing={3} mt={1}>
                {asset.upload ? (
                    <>
                        <GridColumn
                            label="lastUploadDate"
                            value={lastUploadDate}
                        />
                        <GridColumn
                            label="lastUploadSource"
                            value={lastUploadSource}
                        />
                    </>
                ) : null}
                <GridColumn label="lastAuditDate" value={lastAuditDate} />
                <GridColumn label="lastSeenDate" value={lastSeenDate} />
                <GridColumn label="status" value={status} />
                {asset.lastAuditResult && (
                    <GridColumn
                        label="lastAuditResult"
                        value={getAssetStatus(asset.lastAuditResult)}
                    />
                )}

                {asset.monetaryValues ? <MonetaryValues asset={asset} /> : null}
            </Grid>
        </>
    );
};
